import styled from '@emotion/styled'
import { Box } from '@mui/material'
import React from 'react'
// import image from '../../../assets/images/map.jpg'
export const MiniMap = () => {
	const Map = styled('img')(() => ({
		width: '100%',
		height: 100,
		marginTop: 1,
		objectFit: 'cover'
	}))
  return (
	<Box>
		{/* <Map src={image} alt="map" /> */}
	</Box>
  )
}
